import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ShowMore from './show-more';
import HtmlContent from '@medscape-promo/medscapetv/html-content';
import createMarkUp from '@medscape-promo/medscapetv/utils/create-markup';

class AboutSeriesTemplate extends Component {
    constructor(props) {
        super(props);
        //console.log("[AboutSeriesTemplate] props:",props);
    }

    componentDidMount() {
        this.props.onMount();
    }

    render() {
        const { header, content, linksTarget } = this.props;

        return (
        <div className="about-series">
            <div className="header-container">
                <h3 dangerouslySetInnerHTML={createMarkUp(header)}></h3>
            </div>
            <ShowMore>
                <HtmlContent className="content-container" content={content} linksTarget={linksTarget}/>
            </ShowMore>
        </div>
        )
    }
    static get propTypes() {
        return {
            content: PropTypes.string,
            enable: PropTypes.bool,
            header: PropTypes.string,
            onMount: PropTypes.func,
            linksTarget: PropTypes.string
        }
    }
    static get defaultProps() {
        return {
            content: "",
            enable: false,
            header: "About this Series",
            onMount: () => {}
        }
    }
}



export default AboutSeriesTemplate